import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const Hero = ({ data, onContactClick, onCallClick }) => {
  const scrollToContent = () => {
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={data.backgroundImage}
          alt="SEFER Food"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/70 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-8xl mx-auto px-6 lg:px-12 w-full">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-[#C8102E] text-sm tracking-[0.2em] font-medium uppercase mb-6"
          >
            {data.eyebrow}
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-white font-bold text-6xl md:text-7xl lg:text-8xl leading-tight mb-6 whitespace-pre-line"
            style={{ fontFamily: "'Ubuntu', sans-serif" }}
          >
            {data.headline}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-[#F0EBE3] text-lg md:text-xl leading-relaxed mb-10 max-w-2xl"
            style={{ fontFamily: "'Ubuntu', sans-serif" }}
          >
            {data.subheadline}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <button
              onClick={onContactClick}
              className="bg-[#C8102E] text-white px-8 py-4 rounded-full font-medium hover:bg-[#A00D25] transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-[#C8102E]/50"
            >
              Pitch Deck Talep Et →
            </button>
            <button
              onClick={onCallClick}
              className="border-2 border-white text-white px-8 py-4 rounded-full font-medium hover:bg-white hover:text-[#0A0A0A] transition-all duration-300"
            >
              Görüşme Ayarla
            </button>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 1 }}
        onClick={scrollToContent}
        className="absolute bottom-8 left-6 lg:left-12 flex items-center gap-3 cursor-pointer group"
      >
        <div className="w-px h-16 bg-[#C8102E]"></div>
        <span className="text-[#C8102E] text-sm tracking-wider uppercase group-hover:translate-x-1 transition-transform duration-300">
          Keşfet
        </span>
        <ChevronDown className="text-[#C8102E] w-4 h-4 animate-bounce" />
      </motion.div>
    </section>
  );
};

export default Hero;
